import React, { lazy } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";

import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import Card from "../../components/Card/index";
import Fade from "react-reveal/Fade";

// const Card = lazy(() => import("../../components/Card/index"));

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 5rem 0;
`;

const Title = styled.h1`
  color: #0a0b10;
  display: inline-block;
  font-size: calc(1rem + 1.5vw);
  margin-top: 1.5rem;
  position: relative;
  &::before {
    content: "";
    height: 1px;
    width: 50%;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0.5rem);
    /* or 100px */
    border-bottom: 2px solid var(--purple);
  }
`;

const Carousal = styled.div`
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only Screen and (max-width: 40em) {
    width: 90vw;
    .slick-slider .slick-arrow {
      display: none;
    }
  }
  .slick-slider .slick-arrow:before {
    color: #0a0b10;
    font-size: 1.5rem;
    @media only Screen and (max-width: 40em) {
      display: none;
    }
  }
  .slick-slider .slick-dots button:before {
    color: #0a0b10;
    font-size: 1.5rem;
  }
  .slick-slide.slick-active {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    margin-bottom: 3rem;
  }
`;

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,

    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Section>
      <Fade top>
        <Title>OUR BATTALION</Title>
      </Fade>
      {/* <Carousal>
        <Slider {...settings}> */}

      <Container fluid>
        <Row>
          <Col md={2}>
            <Fade top>
              {" "}
              <center>
                <Card
                  //       text="CodeBucks has been essential part of our business. I would definetly
                  // recommend CodeBucks. It has been amazing to have them."
                  name="THE CEO"
                  image="avatar-1"
                />
              </center>
            </Fade>
          </Col>
          <Col md={{ span: 1, offset: 0 }}></Col>
          <Col md={2}>
            <Fade right>
              {" "}
              <center>
                <Card
                  // text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
                  name="MD"
                  image="avatar-2"
                />
              </center>
            </Fade>
          </Col>
          <Col md={{ span: 1, offset: 0 }}></Col>
          <Col md={2}>
            <Fade left>
              {" "}
              <center>
                <Card
                  // text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
                  name="MD"
                  image="avatar-3"
                />
              </center>
            </Fade>
          </Col>
          <Col md={{ span: 1, offset: 0 }}></Col>
          <Col md={2}>
            <Fade bottom>
              <center>
                <Card
                  // text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
                  name="DIRECTOR"
                  image="avatar-4"
                />
              </center>
            </Fade>
          </Col>
        </Row>
      </Container>
      {/* <Card
        text="CodeBucks has been essential part of our business. I would definetly
        recommend CodeBucks. It has been amazing to have them."
        name="THE CEO"
        image="avatar-1"
      />

      <Card
        text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
        name="MD"
        image="avatar-2"
      />

      <Card
        text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
        name="MD"
        image="avatar-3"
      />

      <Card
        text="CodeBucks has been essential part of our business. I would definetly recommend CodeBucks. It has been amazing to have them."
        name="DIRECTOR"
        image="avatar-4"
      /> */}

      {/* </Slider>
      </Carousal> */}
    </Section>
  );
};

export default Testimonials;
